import type { CatalogCellData, CatalogFeature } from '../types';

/**
 * Returns a cell to read display data from when the productId isn't in
 * feature.products[]. Used to render the title/section/badge for a disabled
 * row that the current plan doesn't qualify for.
 */
export function representativeCell(feature: CatalogFeature): CatalogCellData {
  const firstId = Object.keys(feature.cells)[0];
  return feature.cells[firstId] ?? feature.metadata;
}
